<template>
    <div class="flex flex-col w-full">
        <div class="flex items-center mb-1">
            <div class="mr-4">
                <label v-if="label" :for="id" class="font-bold">{{ label }}</label>
            </div>
            <div>
                <span v-if="error" class="mt-1 text-xs text-italic mt-1 text-red-500">
                    {{ error }}
                </span>
            </div>
        </div>
        <div class="my-quill-editor">
            <quill-editor
                v-model="content"
                :options="{
                    ...editorOptions,
                    ...{
                        placeholder: placeholder,
                        modules: {
                            toolbar: toolbarOptions
                        }
                    }
                }"
            >
            </quill-editor>
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import FormInputsMixin from './form_inputs_mixin';

export default {
    components: {
        quillEditor: async () => {
            const quill = await import(/* webpackChunkName: "lazy-loaded/vue-quill-editor" */ 'vue-quill-editor');

            return quill.quillEditor;
        }
    },

    mixins: [FormInputsMixin],

    props: {
        editorOptions: {
            type: Object,
            default: () => {}
        },
        value: {
            type: String,
            default: null
        },
        toolbarOptions: {
            type: Array,
            default: () => [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']]
        }
    },

    data() {
        return {
            content: this.value
        };
    },

    watch: {
        content: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('input', newVal);
            }
        },

        value: function(newVal, oldVal) {
            if (this.content !== newVal && newVal !== oldVal) {
                this.content = newVal;
            }
        }
    }
};
</script>

<style>
.my-quill-editor .ql-toolbar {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}

.my-quill-editor .ql-container {
    border-bottom-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    height: 150px;
}
</style>
